import { Children, ReactElement, cloneElement } from 'react';
import styles from '../styles.module.scss';
import { isReactElementWithProps } from 'components/types';

interface RightGroupProps {
  children: ReactElement | (ReactElement | boolean)[] | boolean;
}

const RightGroup = ({ children }: RightGroupProps) => (
  <div className={styles.rightGroup}>
    {Children.map(children, (child) => {
      if (isReactElementWithProps(child)) {
        return cloneElement(child, {
          ...child.props,
          className: `${child.props.className} ${styles.button}`,
        });
      }
      return null;
    })}
  </div>
);

RightGroup.displayName = 'RightGroup';

export default RightGroup;
